<script lang="ts">
    import { getModalStore } from "@skeletonlabs/skeleton";

    import { Auth } from "@grantscout/auth-ui-svelte";

    const modalStore = getModalStore();

    const theme = {
        default: {
            colors: {
                brand: "#343330",
                brandAccent: "hsl(154 54.8% 45.1%)",
                brandButtonText: "white",
                defaultButtonBackground: "#eeeae3",
                defaultButtonBackgroundHover: "#eaeaea",
                defaultButtonBorder: "lightgray",
                defaultButtonText: "gray",
                dividerBackground: "#eaeaea",
                inputBackground: "transparent",
                inputBorder: "lightgray",
                inputBorderHover: "gray",
                inputBorderFocus: "gray",
                inputText: "black",
                inputLabelText: "black",
                inputPlaceholder: "darkgray",
                messageText: "#2b805a",
                messageBackground: "#e7fcf1",
                messageBorder: "#d0f3e1",
                messageTextDanger: "#ff6369",
                messageBackgroundDanger: "#fff8f8",
                messageBorderDanger: "#822025",
                anchorTextColor: "blue",
                anchorTextHoverColor: "lightblue",
            },
            space: {
                spaceSmall: "4px",
                spaceMedium: "8px",
                spaceLarge: "16px",
                labelBottomMargin: "8px",
                anchorBottomMargin: "4px",
                emailInputSpacing: "4px",
                socialAuthSpacing: "4px",
                buttonPadding: "10px 15px",
                inputPadding: "10px 15px",
            },
            fontSizes: {
                baseBodySize: "13px",
                baseInputSize: "14px",
                baseLabelSize: "14px",
                baseButtonSize: "14px",
            },
            fonts: {
                bodyFontFamily: `Manrope, sans-serif`,
                buttonFontFamily: `Manrope, sans-serif`,
                inputFontFamily: `Manrope, sans-serif`,
                labelFontFamily: `Manrope, sans-serif`,
            },
            borderWidths: {
                buttonBorderWidth: "1px",
                inputBorderWidth: "1px",
            },
            radii: {
                borderRadiusButton: "4px",
                buttonBorderRadius: "4px",
                inputBorderRadius: "4px",
            },
        },
    };

    export let queryParams: { [key: string]: string } = {
        access_type: "offline",
    };
</script>

{#if $modalStore[0]}
    <div class="bg-surface-500 p-5 rounded-lg w-modal-slim">
        <header class="font-semibold text-3xl p-5">Sign in to Arwin</header>
        <Auth
            supabaseClient={$modalStore[0].meta.data.supabase}
            view="sign_in"
            providers={["google", "linkedin_oidc", "slack"]}
            socialButtonSize="xlarge"
            redirectTo={`${$modalStore[0].meta.data.url}/auth/callback`}
            showLinks={true}
            appearance={{ theme }}
            {queryParams}
        />
    </div>
{/if}
